import * as React from 'react'
import { useEffect } from 'react'

import { Layout, LayoutProps } from 'react-admin'

import { useGetApiUsersMe } from './../codegen/generated/users'
import { useUserStore } from './../stores/useUserStore'
import { AppBar } from './AppBar/AppBar'
import { Menu } from './Menu'

export const LXLayout = (props: LayoutProps): JSX.Element => {
  const meQuery = useGetApiUsersMe()

  useEffect(() => {
    if (meQuery.data?.body) {
      useUserStore.setState({
        me: meQuery.data.body,
      })
    }
  }, [meQuery.data?.body])

  return <Layout {...props} menu={Menu} appBar={AppBar} />
}
